const payment_cred = {
    // production
    snap_payments: {
        client_secret: "501A-iacgIXXVpN3oidgARLkOVPdHWO6UYAPC3XAgiHDGFMphsHxflm5MztgEUfa",
        client_id: "6HmCiDZu1mRYOWWhtKy5LZ5RgcZIVmsI"
    },
    // sandbox
    // snap_payments: {
    //     client_secret: "XYyrg5oS4XbTFSz40Mh74U3Aj28AHUSKSgtueOPs68jFF0FT-gxCz_Tfx6GcGP93",
    //     client_id: "mnFvzVldKIDxyTQhY5bLf5D7vXeIeeyN"
    // },
    // production
    stripe_payments: {
        client_secret: "pk_live_51M7a68CwyELXggv4cqDsrMbJyREtNGfwZ5Y2bOB7sfgLKAmsETWevtPaKX0whmWDDD1rIdQnw2rflO4RWVxNYZYu00JDW0QgKh",
        serevr_key: "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 x"
    },
    // sandbox
    // stripe_payments: {
    //     client_secret: "pk_live_51M7a68CwyELXggv4cqDsrMbJyREtNGfwZ5Y2bOB7sfgLKAmsETWevtPaKX0whmWDDD1rIdQnw2rflO4RWVxNYZYu00JDW0QgKh",
    //     serevr_key: "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 x"
    // },
    // production
    acima_checkout: {
        merchantId: "loca-35dfa20d-cd34-46be-ad94-fe44f5998891",
        apiKey: "dudYSun8Nd71YnJ4lSx3zXnyrKGR7QHd"
    },
    // sandbox
    // acima_checkout: {
    //     merchantId: "loca-739060b8-850d-43b9-8b3f-eed44b1a282a",
    //     apiKey: "MQwvUhsLCSqxjRSQfM7a4ewf"
    // },
    // sandbox
    paypal: {
        clientId: "AQcf8awWXjE-xOV4csjYiqJZ5Ow1GmgtTbEecuEZpES3_CXe37tVboQSfwmpH-qSdbrhtXBEqx87EMSC",
        client_secret: "ENVu3QQMNqQXcGHU2xGQjeRtAftmbbUgMcBZmrvnQUSyoM28RZjyzQ9G_x5PlDD3AtmTflIj_WRcYqKp"
    },
};

export default payment_cred;
